<template>
  <div id="app">
    <p>SHARE PAGE:</p>
    {{file}}
  </div>
</template>

<script>


export default {
  name: 'Share',
  data() {
    return {
      file: null
    }
  },
  mounted() {
    console.log('mounted share')

    navigator.serviceWorker.addEventListener('message', event => {

      console.log('addEventListener message: ',event)
      this.file = event.data;

    });
  }
}
</script>

<style>
</style>
